const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
    api: "https://api.hoani.org/",
    paht_api: "https://localhost:5002/",
    media_url: "https://api.hoani.org/",
    domainAdminSide: "http://localhost:3000",
    domainUserSide: "http://localhost:3000",
    domainName: "",
  },
  production: {
    api: "https://api.hoani.org/",
    paht_api: "https://api.hoani.org/",
    media_url: "https://api.hoani.org/",
    domainAdminSide: "https://hoani.org",
    domainUserSide: "https://hoani.org",
    domainName: "hoani.org",
  },
};

module.exports = apiEnvironment[env];
